// Конфигурация колонок таблицы «Рейтинг 2.0».
// Группы (шапка верхнего уровня) и колонки внутри них.
import { ServiceTypeKind } from '../../../interfaces';

export interface IV2ColumnGroup {
  title: string;
  columns: string[];
}

// Первые две группы одинаковы у обеих методик, меняется только третья
const COMMON_GROUPS: IV2ColumnGroup[] = [
  { title: '1 — Отношение', columns: ['Оценка МО'] },
  {
    title: '2 — Качество',
    columns: [
      'Благодарности от жителей',
      'Благодарности от ОВКС',
      'Жалобы от жителей',
      'Протокола от ОВКС',
      'Замечания от жителей',
      'Акты ОВКС',
      'NPS',
    ],
  },
];

// Резидентные оцениваются по команде, выездные — по заявкам
const TEAM_GROUP: IV2ColumnGroup = { title: '3 — Команда', columns: ['Текучесть персонала', 'QMPC'] };
const APPLICATION_GROUP: IV2ColumnGroup = { title: '3 — Заявки', columns: ['SLA по просрочке', 'Кол-во заявок'] };

export const V2_COLUMN_GROUPS = (kind?: ServiceTypeKind): IV2ColumnGroup[] => [
  ...COMMON_GROUPS,
  kind === 'OUTSIDE' ? APPLICATION_GROUP : TEAM_GROUP,
];

// 1 колонка под «ЖК» + все колонки групп; число одинаково для обеих методик
export const V2_TABLE_COLUMN_COUNT = 1 + V2_COLUMN_GROUPS().reduce((sum, group) => sum + group.columns.length, 0);

// Ширина колонки «ЖК». Общая для родительской и вложенной (помесячной) таблиц — для выравнивания колонок.
export const REAL_ESTATE_COLUMN_WIDTH = 220;
